export const line = (ctx, attribs, a, b) => {
    if (attribs.stroke === "none")
        return;
    ctx.beginPath();
    ctx.moveTo(a[0], a[1]);
    ctx.lineTo(b[0], b[1]);
    ctx.stroke();
};
export const lines = (ctx, attribs, pairs) => {
    if (attribs.stroke === "none")
        return;
    ctx.beginPath();
    for (let { 0: a, 1: b } of pairs) {
        ctx.moveTo(a[0], a[1]);
        ctx.lineTo(b[0], b[1]);
    }
    ctx.stroke();
};
